import { MileageInformationFragment } from 'generated/resources/graphql'

import { Employee } from 'modules/core/hooks/useCurrentSession'
import { fromCents } from 'modules/core/lib/formatCurrencyUtils'

export type MileageInformationWithIntegerRate = Omit<MileageInformationFragment, 'mileage'> & {
  mileage: Omit<NonNullable<MileageInformationFragment['mileage']>, 'rate'> & {
    rate?: number | null
  }
}

export const getMileageInformationDefaultValues = (
  data?: MileageInformationWithIntegerRate | null,
  employee?: Employee | null
) => {
  return {
    amount: data?.amount ? fromCents(parseInt(data.amount)) : 0,
    currency: data?.currency ?? employee?.legalEntity?.currency ?? 'EUR',
    mileage: fromCents(data?.mileage?.mileage ?? 0),
    calculatedMileage: fromCents(data?.mileage?.calculatedMileage ?? 0),
    units: data?.mileage?.units ?? 'km',
    rate: data?.mileage?.rate ?? null,
  }
}
